import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { LogOut, RefreshCw } from 'lucide-react';

interface SessionExpiryModalProps {
  open: boolean;
  onContinue: () => void;
  onLogout: () => void;
}

export function SessionExpiryModal({ open, onContinue, onLogout }: SessionExpiryModalProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md rounded-2xl border-border/40 bg-background/95 backdrop-blur-xl shadow-xl">
        <AlertDialogHeader className="space-y-3">
          <AlertDialogTitle className="text-lg font-semibold text-foreground">
            Sessão prestes a expirar
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-muted-foreground leading-relaxed">
            Por segurança, sua sessão será encerrada em 5 minutos devido à inatividade.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2 pt-2">
          <Button
            variant="outline"
            onClick={onLogout}
            className="gap-2 rounded-xl border-border/40"
          >
            <LogOut className="w-4 h-4" />
            Sair agora
          </Button>
          <Button
            onClick={onContinue}
            className="gap-2 rounded-xl"
          >
            <RefreshCw className="w-4 h-4" />
            Continuar sessão
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
